// extracted by mini-css-extract-plugin
module.exports = {"colorYellow200":"#ffd11c","component":"GrandLabel_component__7lmml","text":"GrandLabel_text__Kg1sP"};